var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"frag",rawName:"v-frag"}]},[_vm._t("default",null,{"depositRequestCreatedIds":_vm.depositRequestCreatedIds,"withdrawRequestCreatedIds":_vm.withdrawRequestCreatedIds,"aware":_vm.aware})],2)}
var staticRenderFns = []

export { render, staticRenderFns }